module.exports = __webpack_public_path__ + "static/media/video_tips.8e416124.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/video_tips.png
// module id = 397
// module chunks = 0